import { useState, useEffect } from 'react'
import ScanProgress from '../components/lexis/ScanProgress'
import { api } from '../auth/api'

export default function LexisScan() {
    const [path, setPath] = useState('')
    const [recursive, setRecursive] = useState(true)
    const [jobId, setJobId] = useState(null)
    const [history, setHistory] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => { loadHistory() }, [])
    const loadHistory = async () => {
        try {
            const res = await api.get('/lexis/scan/history')
            const data = res.data
            setHistory(data.jobs || data.scan_jobs || data.history || [])
        } catch (e) { console.error(e) }
        setLoading(false)
    }

    const handleScan = async (e) => {
        e.preventDefault()
        if (!path.trim()) return
        try {
            const res = await api.post('/lexis/scan', { path, recursive })
            if (res.data.job_id) setJobId(res.data.job_id)
        } catch (e) { console.error('Scan failed:', e) }
    }

    return (
        <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
            <h2 style={{ color: '#f1f5f9', marginTop: 0 }}>📁 Directory Scanner</h2>
            <p style={{ color: '#64748b', marginTop: '-8px', marginBottom: '24px', fontSize: '13px' }}>Quét Thư Mục — Process documents into the knowledge base</p>

            <form onSubmit={handleScan} style={{
                background: 'rgba(30, 41, 59, 0.8)', borderRadius: '12px', padding: '24px',
                border: '1px solid rgba(148,163,184,0.1)', marginBottom: '24px',
            }}>
                <label style={{ color: '#d4af37', fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '8px' }}>
                    Directory Path
                </label>
                <input
                    type="text" value={path} onChange={e => setPath(e.target.value)}
                    placeholder="/root/documents or /mnt/mac_docs"
                    style={{ width: '100%', padding: '12px 16px', background: 'rgba(15, 23, 42, 0.8)', border: '1px solid rgba(148,163,184,0.2)', borderRadius: '8px', color: '#f1f5f9', fontSize: '14px', boxSizing: 'border-box' }}
                    required
                />
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#94a3b8', fontSize: '13px', marginTop: '16px', marginBottom: '20px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={recursive} onChange={e => setRecursive(e.target.checked)}
                        style={{ accentColor: '#d4af37' }} /> Recursive
                </label>
                <button type="submit" style={{
                    width: '100%', padding: '12px', background: 'rgba(212,175,55,0.15)',
                    border: '1px solid rgba(212,175,55,0.3)', borderRadius: '8px',
                    color: '#d4af37', cursor: 'pointer', fontSize: '14px', fontWeight: 600,
                }}>🔍 Start Scan</button>
            </form>

            {jobId && <ScanProgress jobId={jobId} />}

            {jobId && (
                <div style={{ marginBottom: '24px' }}>
                    <button onClick={() => setJobId(null)} style={{
                        padding: '8px 16px', background: 'rgba(30,41,59,0.8)',
                        border: '1px solid rgba(148,163,184,0.2)', borderRadius: '8px',
                        color: '#94a3b8', cursor: 'pointer', fontSize: '13px',
                    }}>Dismiss Progress</button>
                </div>
            )}

            {!loading && (
                <div>
                    <h3 style={{ color: '#d4af37', fontSize: '14px' }}>📋 Scan History</h3>
                    {history.length === 0 ? (
                        <p style={{ color: '#64748b', fontSize: '13px' }}>No scan jobs yet.</p>
                    ) : (
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                                <thead>
                                    <tr style={{ borderBottom: '1px solid rgba(148,163,184,0.2)' }}>
                                        <th style={{ textAlign: 'left', padding: '10px 8px', color: '#94a3b8' }}>Date</th>
                                        <th style={{ textAlign: 'left', padding: '10px 8px', color: '#94a3b8' }}>Path</th>
                                        <th style={{ textAlign: 'center', padding: '10px 8px', color: '#94a3b8' }}>Status</th>
                                        <th style={{ textAlign: 'center', padding: '10px 8px', color: '#94a3b8' }}>Processed</th>
                                        <th style={{ textAlign: 'center', padding: '10px 8px', color: '#94a3b8' }}>Failed</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {history.map((j, i) => (
                                        <tr key={i} style={{ borderBottom: '1px solid rgba(148,163,184,0.1)' }}>
                                            <td style={{ padding: '10px 8px', color: '#94a3b8' }}>
                                                {j.created_at || j.started_at ? new Date(j.created_at || j.started_at).toLocaleDateString() : '—'}
                                            </td>
                                            <td style={{ padding: '10px 8px', color: '#e2e8f0' }}>{j.scan_path || j.path || '—'}</td>
                                            <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                                                <span style={{
                                                    background: j.status === 'completed' ? 'rgba(34,197,94,0.15)' : j.status === 'failed' ? 'rgba(239,68,68,0.15)' : 'rgba(245,158,11,0.15)',
                                                    color: j.status === 'completed' ? '#22c55e' : j.status === 'failed' ? '#ef4444' : '#f59e0b',
                                                    padding: '2px 10px', borderRadius: '99px', fontSize: '11px', fontWeight: 600,
                                                }}>{j.status || 'unknown'}</span>
                                            </td>
                                            <td style={{ padding: '10px 8px', textAlign: 'center', color: '#22c55e' }}>{j.processed_files || 0}</td>
                                            <td style={{ padding: '10px 8px', textAlign: 'center', color: '#ef4444' }}>{j.failed_files || 0}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}